import type { Locale } from './locale';
import { homePageEn } from './homePage.en';
import { homePageEs } from './homePage.es';

export type HomeFaqItem = {
    question: string;
    answer: string;
};

export type HomeCard = {
    title: string;
    body: string;
};

export type HomeProblemCard = {
    icon: string;
    title: string;
    body: string;
};

export type HomeModuleBlock = {
    imageAlt: string;
    label: string;
    title: string;
    body: string;
    bullets: string[];
};

export type HomeRoleCard = {
    title: string;
    bullets: string[];
};

export type HomePageCopy = {
    hero: {
        badge: string;
        title: string;
        description: string;
        startFreeDemo: string;
        contactUs: string;
        heroImageAlt: string;
    };
    trust: {
        title: string;
        subtitle: string;
        cards: HomeCard[];
    };
    problems: {
        imageAlt: string;
        title: string;
        cards: HomeProblemCard[];
    };
    connected: {
        title: string;
        subtitle: string;
        cards: HomeCard[];
    };
    modules: {
        sectionTitle: string;
        sectionSubtitle: string;
        coreHeader: { highlight: string; rest: string; subtitle: string };
        learnMore: string;
        core: HomeModuleBlock[];
        addonHeader: { highlight: string; rest: string; subtitle: string };
        addons: HomeModuleBlock[];
        coreImages: string[];
        addonImages: string[];
    };
    pricing: {
        title: string;
        body: string;
        startFreeDemo: string;
        contactQuote: string;
        imageAlt: string;
    };
    trial: {
        title: string;
        body: string;
        cta: string;
        imageAlt: string;
    };
    roles: {
        title: string;
        cards: HomeRoleCard[];
    };
    testimonials: {
        label: string;
        title: string;
        ratingsLabel: string;
        authorPlaceholder: string;
        rolePlaceholder: string;
        prevAria: string;
        nextAria: string;
        quotes: string[];
    };
    faq: {
        label: string;
        title: string;
        items: HomeFaqItem[];
    };
    finalCta: {
        title: string;
        body: string;
        startFreeDemo: string;
        contactUs: string;
        imageAlt: string;
    };
};

export function getHomePageCopy(locale: Locale): HomePageCopy {
    return locale === 'es' ? homePageEs : homePageEn;
}
